import { render, staticRenderFns } from "./QuestionMatrixBlank.vue?vue&type=template&id=4cac582b&scoped=true&"
import script from "./QuestionMatrixBlank.vue?vue&type=script&lang=js&"
export * from "./QuestionMatrixBlank.vue?vue&type=script&lang=js&"
import style0 from "./QuestionMatrixBlank.vue?vue&type=style&index=0&id=4cac582b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cac582b",
  null
  
)

export default component.exports